export const userRoleMap = {
    'Creator': 'OKTA_Transmission-Checklist-Creator',
    'Admin': 'OKTA_Transmission-Checklist-Administrator',
    'ViewOnly': 'OKTA_Transmission-Checklist-ViewOnly',
    'Internal': 'OKTA_Transmission-Checklist-InternalContributor',
    'External': 'Transmission-Checklist-External-Contributor',
    'ExternalViewOnly': 'Transmission-Checklist-External-ViewOnly',
    'DTCreator':'OKTA_Transmission-Checklist-DTCreator',
    'FMPCreator': 'OKTA_Transmission-Checklist-FMPCreator',
    'External_aep': 'OKTA_Transmission-Checklist-External-Contributor',
    'ExternalViewOnly_aep': 'OKTA_Transmission-Checklist-External-ViewOnly',
}